import { Grid, Space } from "../components/Layout";
import { Media, Title, Texts, Button } from "../components/Object";
import { Head, News, Banner, Contact } from "../components/Project";
import { HashLink } from "react-router-hash-link";
import { Scroll } from "../components/Animation";

const Service = () => {
  return (
    <>
      <Head slug="page-porter"></Head>

      <div className="l-row">
        <div className="p-box__wrap--about">
          <Space size={["160px", "64px"]} />
          <Space size={["0px 0 64px", "0px 0 40px"]}>
            <Texts
              slug="about/title"
              addText="旅行中のお荷物、<br>お任せください！"
            ></Texts>
          </Space>
          <Texts
            slug="about/body"
            addText="旅行時にお荷物で煩わしさを感じたこと、ありませんか？<br>当社のポーターサービスとは、大きな荷物を持たず、気ままに観光していただくことを目的としたサービスです。ご家族様でのご利用が多いですが、団体様も大歓迎です。<br>お気軽にお問い合わせください。"
          ></Texts>
          <Space size={["160px", "80px"]} />

        </div>
    
        <div className="c-grid--center">
          <Title slug="problem" type="en-single"></Title>
        </div>
        <Space size={['48px 0 0', '24px 0 0']}>
          <Media sp="sp" src="porter/main" alt="problem" class="p-img__problem--porter"></Media>
        </Space>

        <Space size={['120px', '80px']}></Space>
      </div>

      <Point />

      <Contact />

      <News />

      <Banner />
    </>
  );
};

const CanList = () => {
  const args = {
    slug: "company",
    length: 3,
    addText: [
      [
        "小規模、中規模の保管・配送承ります。<br>自転車・トイレットペーパー・水・包材など",
        "お店を経営していると、商品の保管場所に困ったりしていませんか？<br>保管場所だけに倉庫を借りるのは…。というお客様にお喜びいただいております。<br>1 パレットの少量でのご利用も大歓迎です。",
      ],
      [
        "自社ドライバーさん、<br>まだ遠方まで配送していませんか？",
        "運送ドライバーさんを自社で雇われている企業様も多いかと思います。<br>例えば、京都の会社様が姫路まで単独便で配送をしていると、人件費や所要時間を考えると割に合わないかと思います。<br>当社に配送を依頼することにより、人件費や時間を有効的に使うことができます。",
      ],
      [
        "梱包・軽作業・各種配送業務承ります。",
        "個人様、法人様、教育機関など、多岐にわたる業種の企業様からご利用頂いおております。<br>封入作業やセットアップ、発送代行など少ない量から大きな量まで承ります。お気軽にご相談ください。",
      ],
    ],
  };
  const Item = (props) => {
    return (
      <>
        <li className="items c-grid__items--com" data-state={props.index % 2 ? 'right' : 'left'}>
          <div className="l-row">
            <div className="c-grid__items--com__inner">
              <Media class="p-img__number" src={`point/num${props.index}`} alt="number"></Media>
              <Texts
                class="c-text--main"
                slug={`feature/title${props.index}`}
                addText={args.addText[props.index][0]}
              ></Texts>
              <div className="pc"></div>
              <Texts
                slug={`feature/body${props.index}`}
                addText={args.addText[props.index][1]}
              ></Texts>
            </div>
          </div>
          <div className="l-row" data-state={props.index % 2 ? 'right' : 'left'}>
            <Scroll>
              <Media class="p-img__company" state={props.index % 2 ? 'right' : 'left'} alt="media" src={`company/list${props.index}`}></Media>
            </Scroll>
          </div>
        </li>
      </>
    );
  };
  let items = [];
  for (let i = 0; i < args.length; i++) {
    items.push(<Item key={i} index={i}></Item>);
  }

  return (
    <>
      <Title slug="feature" enClass="c-text--center" jpClass="c-text--center"></Title>
      <Space size={['80px 0 0', '80px 0 0']}>
        <Space size={['0 0 48px', '0 0 32px']}>
          {/* <Texts slug="feature/body" class="c-text--center"></Texts> */}
        <ul className="list c-grid__list--com" data-state="service">
          {items}
        </ul>
        </Space>
      </Space>
    </>
  );
};

const Point = () => {
  return(
    <>
      <div className="p-box__wrap--white">
        <Space size={['120px', '80px']}></Space>
        <div className="l-row">
          <div className="c-grid--center">
            <Title type="center" slug="service-porter" enClass="c-text--center" jpClass="c-text--center"></Title>
          </div>
        </div>
        <Space size={["80px 0 0", "80px 0 0"]}>
          <PointList />
        </Space>
        <Space size={['120px', '80px']}></Space>
      </div>
    </>
  )
}
const PointList = () => {
  const Item = (props) => {
    return (
      <>
        <li className="items c-grid__items--porter" data-state="">

          <Media src={'porter/list'+props.index} alt="media"/>
          <div className="c-grid__items--porter__inner">
            <Texts
              slug={`porter-service/title${props.index}`}
              class="c-text--main"
            ></Texts>
            <Space size={["40px", "32px"]} />
            <Texts
              slug={`porter-service/content${props.index}`}
            ></Texts>
          </div>
        </li>
      </>
    );
  };
  let items = [];
  for (let i = 0; i < 1; i++) {
    items.push(<Item key={i} index={i}></Item>);
  }

  return (
    <>
      <div className="l-row" data-state="left">
        <ul className="list c-grid__list--porter" data-state="">
          {items}
        </ul>
      </div>
    </>
  );
};

export default Service;